import { useCallback, useMemo } from 'react';

import MarkNotificationsRead from 'my-components/MarkNotificationsRead';
import { QuestionEventsProvider } from 'my-components/OnlineCourseQuestion/QuestionEventsContext';

import OnlineCourseQuestionForm from './OnlineCourseQuestionForm';
import OnlineCourseQuestionsListCtnr from './OnlineCourseQuestionsListCtnr';

import Typography from '@mui/material/Typography';

export default function ActivityQuestions(props) {
  const {
    activity,
    assignmentId,
    courseId,
    enableTour,
    eventTrackingProperties,
    hideQuestionForm,
    onlineCourse,
    onlineCourseId,
    onPurchase,
    practiceModeSectionId,
    quizQuestionId,
    subQuestionId,
    subQuestions,
  } = props;

  // One asked with no part open (the passage alone, or from before parts were recorded), or on a part an author
  // has since deleted, is about every part.
  const questionsFilter = useCallback(
    question =>
      (!quizQuestionId || question.quiz_question_id === quizQuestionId) &&
      (!subQuestionId ||
        question.sub_question_id === subQuestionId ||
        !subQuestions.some(sq => sq.id === question.sub_question_id)),
    [quizQuestionId, subQuestionId, subQuestions],
  );
  const defaultQuestionParams = useMemo(
    () => ({
      pm_section_id: practiceModeSectionId,
      quiz_question_id: quizQuestionId,
      sub_question_id: subQuestionId,
      assignment_id: assignmentId,
    }),
    [quizQuestionId, practiceModeSectionId, subQuestionId, assignmentId],
  );

  return (
    <div css={({ spacing }) => ({ '& > * + *': { marginTop: spacing(2) } })}>
      <MarkNotificationsRead groupKey={`${activity.base_type}${activity.id}`} type="OnlineCourseQuestion" />

      {hideQuestionForm ?
        <Typography gutterBottom variant="subtitle1">
          Student Questions
        </Typography>
      : <OnlineCourseQuestionForm
          courseId={courseId}
          defaultQuestionParams={defaultQuestionParams}
          enableTour={enableTour}
          eventTrackingProperties={eventTrackingProperties}
          onlineCourse={onlineCourse}
          onlineCourseId={onlineCourseId}
          onPurchase={onPurchase}
          questionableId={activity.id}
          questionableType={activity.base_type}
        />
      }
      <QuestionEventsProvider value={eventTrackingProperties}>
        <OnlineCourseQuestionsListCtnr
          instructorId={onlineCourse?.instructor_id}
          onlineCourseId={onlineCourse?.id || onlineCourseId}
          questionableId={activity.id}
          questionableType={activity.base_type}
          questionsFilter={Boolean(quizQuestionId || subQuestionId) && questionsFilter}
        />
      </QuestionEventsProvider>
    </div>
  );
}
